import styled from "styled-components";

export const FieldSelectContainer = styled.div`
	margin-bottom: 2em;
`;
